import { leadsImportListOptions } from '@crm/api'
import { AppLink } from '@crm/components'
import { ImportInfo } from '@crm/features/leads/components'
import { paths } from '@crm/routes'
import { TitleSection } from '@shared/components'
import { useQueryParams } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { defaultFilters } from '@shared/utils'
import { useQuery } from '@tanstack/react-query'
import { Button, Card, Flex } from 'antd'

export const LeadImport = () => {
  const { t } = useLocales()
  const params = useQueryParams()

  const { data: dataLeadsImport } = useQuery({
    ...leadsImportListOptions({ query: { ...defaultFilters, ...params } })
  })

  return (
    <Flex vertical>
      <TitleSection
        title={t(`import.progress_list`)}
        count={dataLeadsImport?.count}
      >
        <AppLink to={paths.leadImport.first}>
          <Button type="primary">{t('import.contact')}</Button>
        </AppLink>
      </TitleSection>

      <Card variant="borderless">
        <ImportInfo item={dataLeadsImport} />
      </Card>
    </Flex>
  )
}
